import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=a09b44a6&scoped=true&"
import script from "./pic.vue?vue&type=script&lang=js&"
export * from "./pic.vue?vue&type=script&lang=js&"
import style0 from "./pic.vue?vue&type=style&index=0&id=a09b44a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09b44a6",
  null
  
)

export default component.exports